(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-cbd-package-video"] && !Shopify.designMode) return;
  try {
    
const initCbdBanners=()=>{
 document.querySelectorAll('[data-pp-banner-prices]').forEach(box=>{
  if(box.dataset.initialized)return;box.dataset.initialized='true';
  const groups=Array.from(box.querySelectorAll('[data-pp-banner-group]'));let index=0;
  if(!window.matchMedia('(prefers-reduced-motion: reduce)').matches){setInterval(()=>{if(document.hidden||box.matches(':hover,:focus-within'))return;groups[index].hidden=true;index=(index+1)%groups.length;groups[index].hidden=false;},6000);}
 });
 document.querySelectorAll('.pp-cbd-video__media').forEach(video=>{video.muted=true;video.play().catch(()=>{});});
};
initCbdBanners();document.addEventListener('shopify:section:load',initCbdBanners);

  } catch(e) { console.error(e); }
})();
})();
